var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPickup = function SvgIconPickup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.087,
    height: 22.274,
    viewBox: "0 0 18.087 22.274",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9436",
    "data-name": "Grupo 9436",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 652.815, -3722.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6330",
    "data-name": "Caminho 6330",
    d: "M-518.374,3743.589a1.073,1.073,0,0,0-.95.511,13.564,13.564,0,0,0-1.615,2.546.774.774,0,0,0,.653,1.016l10.965.5a.706.706,0,0,0,.649-.388l1.307-2.458a.787.787,0,0,0-.584-1.172Z",
    transform: "translate(-0.521 -0.254)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9418",
    "data-name": "Grupo 9418",
    transform: "translate(-521.729 3746.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6331",
    "data-name": "Caminho 6331",
    d: "M-509.811,3758.726l-9.806-.362a.8.8,0,0,0-.792.747l-1.316,12.861a.831.831,0,0,0,.646.924l2.208.379,4.578.785,3.887.668a1.15,1.15,0,0,0,1.132-.219,1.3,1.3,0,0,0,.245-.948l-.035-.663-.1-1.865-.261-4.947-.253-4.8-.133-2.516Z",
    transform: "translate(521.729 -3755.615)",
    fill: "#191750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6332",
    "data-name": "Caminho 6332",
    d: "M-476.208,3765.7l-2.573-15.444-1.537,2.726a.818.818,0,0,1-.2.227l.791,15.006a.464.464,0,0,0,.753.376l2.475-2.074A.88.88,0,0,0-476.208,3765.7Z",
    transform: "translate(493.624 -3750.255)",
    fill: "#191750"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPickup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_pickup.e0a8397f.svg";
export { ForwardRef as ReactComponent };